import { Typography } from "@packages/ds";
import styled from "styled-components";

export const ScopesText = styled.p`
  padding-bottom: 24px;
`;

export const TitleScopesText = styled.p`
  padding-bottom: 5px;
  padding-top: 16px;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
  margin-left: 0px;
`;
